import { injectScript } from '@/utils/vuex'

export default {
    async fetch({ commit, state }) {
        commit('enable', await injectScript(state.url))
    }
}
